/*
 * Return a proper test id for the element
 * @param value - The value to be used as test id
 * @param prefix - The prefix to be used for the test id
 * @example
 * getDynamicTestId('Test Value', 'prefix') // prefix-test_value
 */

export const getDynamicTestId = (value: string, prefix = '') =>
  `${prefix && `${prefix}-`}${value}`.toLowerCase().replace(/ /g, '_');
